import dayjs from "dayjs";
import { formatAddress } from "@therms/web-js";
import * as xlsx from "xlsx";
//#region src/modules/Locations/shared/LocationLogEntries/location-log-entries-summary-download.ts
function locationLogEntriesSummaryDownload(entries, deps, config) {
	const arrayOfArrays = [[
		"ID",
		"Location",
		"Address",
		"Entry Type",
		"Date",
		"Time",
		"Duration (min)",
		"Activity Types",
		"Author"
	]];
	entries.forEach((entry) => {
		let userString = "";
		if (entry.createdByUser?.displayName) userString += entry.createdByUser?.displayName;
		if (entry.createdByUser?.idNumber) userString += ` (${entry.createdByUser?.idNumber})`;
		arrayOfArrays.push([
			entry.idLabel || "",
			entry.locationId ? deps.locationsById[entry.locationId]?.name : "",
			entry.locationId && deps.locationsById[entry.locationId]?.address ? formatAddress(deps.locationsById[entry.locationId]?.address, true) : "",
			entry.entryType.name,
			dayjs(entry.timestamp).format("YYYY/MM/DD"),
			dayjs(entry.timestamp).format("hh:mm A"),
			entry.timeDurationMin || "",
			entry.activityTypeTags.map((activityType) => activityType.title).join(", "),
			userString
		]);
	});
	const ws = xlsx.utils.aoa_to_sheet(arrayOfArrays);
	const wb = xlsx.utils.book_new();
	xlsx.utils.book_append_sheet(wb, ws, "Summary");
	if (config.format === "csv") xlsx.writeFile(wb, `${config.fileName}.csv`, { bookType: "csv" });
	else xlsx.writeFile(wb, `${config.fileName}.xlsx`, { bookType: "xlsx" });
}
//#endregion
export { locationLogEntriesSummaryDownload };

//# sourceMappingURL=location-log-entries-summary-download.js.map